import { EventLog } from '@types';
import { createAction } from 'typesafe-actions';

export const logApiEvents = createAction('LOG_ANALYTICS_API_EVENT', (event: EventLog) => event)();
export const logUserEvents = createAction('LOG_AMPLIFY_USER_EVENTS', (event: EventLog) => event)();
